module.exports = __webpack_public_path__ + "img/register_bg.5d0ba93b.png";